import FilterForm from '../../../components/forms/FilterForm';
import { Alert, Form, Input, Space, Table } from 'antd';
import { CanAccess, HttpError } from '@refinedev/core';
import { EditButton, ShowButton, TextField, useTable } from '@refinedev/antd';
import { EyeOutlined } from '@ant-design/icons';
import { IProductBundle } from 'interfaces/product_bundles';
import { ListLayout } from 'components/layout/layout/ListLayout';

export const ProductBundleList = () => {
  const { tableProps, searchFormProps } = useTable<
    IProductBundle,
    HttpError,
    { byName: string }
  >({
    onSearch: ({ byName }) => [
      {
        field: 'filter[by_name]',
        operator: 'eq',
        value: byName
      }
    ]
  });

  return (
    <ListLayout title="Combos">
      <Alert
        style={{ marginBottom: '12px' }}
        showIcon
        type="info"
        message="A edição de informações de prateleira do combo é feita através do produto de vitrine, não é possível editar quais cursos pertencem ao combo após sua criação"
      />

      <FilterForm searchFormProps={searchFormProps}>
        <Form.Item name="byName">
          <Input placeholder="Nome do combo" className="lg:w-96" />
        </Form.Item>
      </FilterForm>

      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="name"
          key="name"
          title="Nome"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="product_ids"
          key="product_ids"
          title="Total de cursos"
          render={({ length }) => <TextField value={length} />}
        />
        <Table.Column<IProductBundle>
          title="Ações"
          dataIndex="actions"
          align="center"
          width={120}
          render={(_, record) => {
            return (
              <Space>
                <CanAccess resource="products/bundles" action="edit">
                  <EditButton
                    hideText
                    size="small"
                    recordItemId={record.id}
                    icon={<EyeOutlined />}
                  />
                </CanAccess>
                <CanAccess resource="products/bundles" action="show">
                  <ShowButton hideText size="small" recordItemId={record.id} />
                </CanAccess>
              </Space>
            );
          }}
        />
      </Table>
    </ListLayout>
  );
};
